import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Typography from "@mui/material/Typography";
import AOS from "aos";
import "aos/dist/aos.css";
import Link from "@mui/material/Link";
import BottomCheckOutNav from "../components/BottomCheckOutNav";

const restaurantName = process.env.REACT_APP_RESTAURANT_NAME;
const seniorlivingName = process.env.REACT_APP_SITE_NAME;
const emailAddress = process.env.REACT_APP_CONTACT_US_EMAIL;
const phoneNumber = process.env.REACT_APP_CONTACT_US_PHONE;
const googleMaps = process.env.REACT_APP_GOO_GL_MAPS;
const restaurantAddress = process.env.REACT_APP_RESTAURANT_ADDRESS;
const restaurantURL = process.env.REACT_APP_SITE;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const buttonText = process.env.REACT_APP_BUTTON_TEXT;
const textHighlight = process.env.REACT_APP_TEXT_HIGHLIGHT;
const enableSL = parseInt(process.env.REACT_APP_ENABLE_SL);

export const RefundPolicySL = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);

  return (
    <div
      data-aos-easing="ease-in-out"
      data-aos-delay="0"
      data-aos="fade-top"
      style={{
        backgroundColor: "whitesmoke",
        minHeight: "100vh",
      }}
    >
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Refund Policy - {`${restaurantName}`}</title>
          <link rel="canonical" href={`${restaurantURL}sl-refund-policy`} />
          <meta
            name="description"
            content="Read our Refund Policy to understand how we collect, use, and protect your personal information."/>
          <meta
            name="keywords"
            content="Refund Policy, data protection, personal information, user privacy, data collection"
          />
          <meta name="author" content={`${restaurantName}`} />
          <meta
            property="og:title"
            content={`Refund Policy - ${restaurantName}`}
          />
          <meta
            property="og:description"
            content="Learn more about our commitment to protecting your personal information in our Refund Policy."
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={`${restaurantURL}sl-refund-policy`}
          />
          <meta property="og:image" content={`${siteMedSrc}logo.webp`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content={`Refund Policy - ${restaurantName}`}
          />
          <meta
            name="twitter:description"
            content="Understand how we safeguard your privacy in our detailed Refund Policy."
          />
          <meta name="twitter:image" content={`${siteMedSrc}logo.webp`} />
        </Helmet>
      </HelmetProvider>
      <div
        className="HeaderImg"
        style={{
          backgroundImage: `url(${siteMedSrc}background.webp)`,
          color: buttonText,
        }}
      >
        <Container>
          <Row>
            <col className="whitespace"></col>
            <Col xs={12}>
              <h2 className="center" style={{ color: textHighlight }}>
                Refund Policy
              </h2>
            </Col>
            <Col xs={10} className="center">
              <h5 className="white"></h5>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="privacy">
        <Row className="left">
          <Col xs={12}>
            <h5 className="MuiContainer-root">Last Updated: May 26, 2025</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              {restaurantName} (“{seniorlivingName},” “<strong>we</strong>,” “
              <strong>our</strong>,” “<strong>us</strong>”) to provide our customers with high-quality food and exceptional service. 
              If you are not satisfied with your order, we are here to help.
            </Typography>
            <h5>1. Eligibility for Refunds</h5>
           <Typography variant="body1" color="text.primary" paragraph>
            Refunds may be considered under the following circumstances:
            <li>You received the wrong order.</li>
            <li>Items are missing from your order.</li>   
            <li>The food was spoiled or not properly cooked.</li> 
            <li>There was a significant delay in delivery or pickup.</li>
            </Typography>
            <h5> 2. How to Request a Refund</h5>
            <Typography variant="body1" color="text.primary" paragraph>
            To request a refund, please contact us within 24 hours of receiving your order:
            <li>Phone: [Insert phone number]</li>
            <li>Email: [Insert email address]</li>
            <li>In-Person: Ask to speak with a manager during your visit.</li>
            <li>Please provide your receipt, a description of the issue, and any relevant photos (if applicable).</li>
            </Typography>

            <h5>3. Refund Options</h5>
            <Typography variant="body1" color="text.primary" paragraph>
             Depending on the situation, we may offer:
             <li>A full or partial refund to your original payment method.</li>
             <li>A store credit or voucher for future use.</li>
             <li>A replacement order at no additional cost.</li>
            </Typography>
            <h5>4. Non-Refundable Situations</h5>
            <Typography variant="body1" color="text.primary" paragraph>
            Refunds will not be issued for:
             <li>Personal taste preferences.</li>
             <li>Orders not picked up or delivered due to incorrect contact information.</li>
             <li>Requests made after the 24-hour window.</li>
            </Typography>
            <h5>5. Manager Discretion</h5>
            <Typography variant="body1" color="text.primary" paragraph>
            All refunds and compensations are subject to management approval. 
            We reserve the right to refuse a refund if the claim is not consistent with our policy.
            Thank you for choosing  {restaurantName}. We value your patronage and are committed to making things right when things go wrong.
            </Typography>
            <h5>Contact Information</h5>
            <Typography variant="body1" color="text.primary" paragraph>
              {seniorlivingName} welcomes your questions or comments regarding
              Refund Policy. If you believe that {seniorlivingName}{" "}
              has not adhered to this Statement, please contact {restaurantName}{" "}
              at:
              <br />
              <strong>Address: </strong>
              <span style={{ textDecoration: "underline" }}>
                <a href={googleMaps} class="f-link" target="_blank">
                  {restaurantAddress}{" "}
                </a>
              </span>
              <br />
              <strong>Telephone number: </strong>
              <span style={{ textDecoration: "underline" }}>
                <a href={`tel:${phoneNumber}`}>{phoneNumber} </a>
                {/* Email Address: <a href={`mailto:${emailAddress}`}>{emailAddress}</a> */}
              </span>
            </Typography>
          </Col>
          <col className="whitespace"></col>
        </Row>
      </Container>
      {enableSL == 1 ? (
        <BottomCheckOutNav
          sx={{
            backgroundColor: "transparent",
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        />
      ) : null}
    </div>
  );
};
